'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'lightbulb';
var width = 384;
var height = 512;
var aliases = [128161];
var unicode = 'f0eb';
var svgPathData = 'M288 358.3c57.4-33.2 96-95.2 96-166.3 0-106-86-192-192-192S0 86 0 192c0 71.1 38.6 133.1 96 166.3l0 25.7 192 0 0-25.7zm0 73.7l-192 0 0 96 192 0 0-96zM184 112c-39.8 0-72 32.2-72 72l0 8-48 0 0-8c0-66.3 53.7-120 120-120l8 0 0 48-8 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLightbulb = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;